/**
 * Copyright 2018 Phenix Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
define([
    'phenix-web-lodash-light',
    'phenix-web-global',
    'phenix-web-event',
    'phenix-web-observable',
    'phenix-web-disposable'
], function(_, global, event, observable, disposable) {
    'use strict';

    function NetworkConnectionMonitor() {
        // Support non-browser environments
        var isOnline = typeof navigator !== 'undefined' ? navigator.onLine : true;

        this._onlineObservable = (new observable.Observable(isOnline)).extend({timeout: 0});
        this._namedEvents = new event.NamedEvents();

        _.addEventListener(global, 'online', _.bind(this._namedEvents.fire, this._namedEvents, 'online', []));
        _.addEventListener(global, 'offline', _.bind(this._namedEvents.fire, this._namedEvents, 'offline', []));
        _.addEventListener(global, 'unload', _.bind(this._namedEvents.dispose, this._namedEvents));

        this._namedEvents.listen('online', _.bind(this._onlineObservable.setValue, this._onlineObservable, true));
        this._namedEvents.listen('offline', _.bind(this._onlineObservable.setValue, this._onlineObservable, false));
    }

    NetworkConnectionMonitor.prototype.listenForNetworkChange = function listenForOffline(callback, hysteresisTimeout) {
        var disposables = new disposable.DisposableList();
        var onOnline = _.bind(handleOnline, this, callback);
        var onOffline = _.bind(handleOfflineWithHysteresis, this, callback, hysteresisTimeout);

        disposables.add(this._namedEvents.listen('online', onOnline));
        disposables.add(this._namedEvents.listen('offline', onOffline));

        return disposables;
    };

    NetworkConnectionMonitor.prototype.isOnline = function isOnline() {
        return this._onlineObservable.getValue();
    };

    function handleOfflineWithHysteresis(callback, hysteresisTimeout) {
        var that = this;

        this._onlineObservable.setValue(false);

        if (!_.isNumber(hysteresisTimeout)) {
            return callback(false);
        }

        that.offlineTimeout = setTimeout(function() {
            if (!callback || that._onlineObservable.getValue()) {
                return;
            }

            callback(false);
        }, hysteresisTimeout);
    }

    function handleOnline(callback) {
        this._onlineObservable.setValue(true);

        if (callback) {
            callback(true);
        }
    }

    return new NetworkConnectionMonitor();
});